import React from 'react';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { IconButton } from '@mui/material';

const CloseIconButton = ({ snackbarKey }) => {
  const { closeSnackbar } = useSnackbar();

  const onClickDismiss = () => {
    closeSnackbar(snackbarKey);
  };

  return (
    <IconButton sx={{ width: 20, height: 20, padding: 0, color: 'white', fontSize: '1.1rem' }} onClick={onClickDismiss}>
      X
    </IconButton>
  );
};

const NotistackProvider = props => {
  const { children } = props;

  return (
    <SnackbarProvider
      dense
      maxSnack={3}
      autoHideDuration={10000}
      action={key => <CloseIconButton snackbarKey={key} />}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      classes={{
        variantInfo: {
          fontSize: '1.4rem',
          whiteSpace: 'pre-line',
        },
        variantSuccess: {
          fontSize: '1.4rem',
          whiteSpace: 'pre-line',
        },
        variantWarning: {
          fontSize: '1.4rem',
          whiteSpace: 'pre-line',
        },
        variantError: {
          fontSize: '1.4rem',
          whiteSpace: 'pre-line',
        },
      }}
    >
      {children}
    </SnackbarProvider>
  );
};

export { NotistackProvider };
